'use client';

import React from 'react';

export function Loader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <svg width="80" height="80" viewBox="0 0 40 40">
        <g>
          <circle cx="20" cy="20" r="16" fill="none" stroke="#4fc3f7" strokeWidth="3" strokeDasharray="25 40" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1s" repeatCount="indefinite" />
          </circle>
          <circle cx="20" cy="20" r="12" fill="none" stroke="#ffb74d" strokeWidth="3" strokeDasharray="20 30" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="360 20 20" to="0 20 20" dur="1.2s" repeatCount="indefinite" />
          </circle>
          <circle cx="20" cy="20" r="8" fill="none" stroke="#ef5350" strokeWidth="3" strokeDasharray="12 20" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.8s" repeatCount="indefinite" />
          </circle>
        </g>
      </svg>
    </div>
  );
} 